module.exports = __webpack_public_path__ + "img/tooth12.37c16e86.png";